var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 451 272",
    width: 451,
    height: 272,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8150831-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 173,
    height: 31,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAK0AAAAfAQMAAACvY99+AAAAAXNSR0IB2cksfwAAAAZQTFRF8Mwv/8MAOg6qBAAAAAJ0Uk5TAP9bkSK1AAAAZ0lEQVR4nLXSsQ3AIAwEwI9SpMwIjJLRYDRGyQguKaIYqP1fUODyZMmW/YCo5KHq4KjegJPwD1yEHbgZFzZxzhT8MH4VZ8a2kRu71GTRvW8TWzxVWuCqfik+L3JyEP5G2HJkA81PQQeYiWxG8VCCUAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 57,
    height: 30,
    id: "img2",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAAeAQMAAACsfyRIAAAAAXNSR0IB2cksfwAAAAZQTFRF8Mwv/8MAOg6qBAAAAAJ0Uk5TAP9bkSK1AAAAWUlEQVR4nGNgkP////8/BiD4DwIHGBiYwYwPDAzsYMYPBgZ+MOMPA1gtEgOozR7M+I/EqIcwGohi/CdFMZyBaSncPXAG3M1wX8D9xQhmPGCAurWBAaIaqBYAWsW7Bjj+XDQAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 31,
    height: 30,
    id: "img3",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAeAQMAAADuPFffAAAAAXNSR0IB2cksfwAAAAZQTFRF8Mwv/8MAOg6qBAAAAAJ0Uk5TAP9bkSK1AAAATklEQVR4nG3NsQ2AMAxE0Y8oUjKCR8loyWgZxSNQpkA5MHKZ5jW27kOdgBacEhRpcEmOSTc1mbTkQXvW9tCSHPj3LPEIjUh2jojz/YI5L2dUXO2aAoQvAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 69,
    height: 30,
    id: "img4",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAeAQMAAABACkFeAAAAAXNSR0IB2cksfwAAAAZQTFRF8Mwv/8MAOg6qBAAAAAJ0Uk5TAP9bkSK1AAAAXUlEQVR4nGNg4P8PAg0MDAz1YNYHBgZGMOP/HwYGZgjrHwNUGUghgiUPZR1gsIeyHmBhfYAajJ31A4n1Hy8LUwd2k+0xWA+QXIpgIfzBDmXBfQ70LwPMMgaoMQ8YAAZI6cwniHMSAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 318,
    height: 212,
    id: "img5",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAT4AAADUAQMAAAA/Xt0jAAAAAXNSR0IB2cksfwAAAAZQTFRF4oAd////7cAahAAAAAJ0Uk5TAP9bkSK1AAADF0lEQVR4nOXZTXakIBAHcHguXHoEjsLR9CZzFXa5hkfopQufzDS0WMVH8TfpvLyZYdVJfq1QVWBApaxvtlXR1nbeO+IGCe4EjhKkl5xEuF3QiNAvKLwGbmW4odAnOHegQ+EDhSnmHXd1sgsdClcUbig8wFGn0fShQ+GKwgdWFCk3fXhAhftsyJwJLU4HeRaGFuMjzuvYYnx0H25oIHd0NGdZNFsaZw+mmy1d+YIOveTaha8gP7rwFTsAGhrx/r33PlRYxNXZSQAaFI5gal6jcX2owdS8RoNAC6Ym1gWQmjhsBA5oDjUKFZrsGB8EWhQaMNkxkAgcwaqIgUSgRqsChgotnxBxGCLlE1IDQXMHQnU2oXBECxKGwx0IVa5+O1RoieNwvgMdAu3PQYPOLhhO3wKh+QrD8S+AA7pU/J9Q/6twkL5BoZEWQE0eC7O0FFAoViaBWhwW6eMgPpsIHFE4iY+cz0AjPkmG74bLW6F9OzTik4SsZj8M1yacPgHlZxP56y3Ynl3m7dBecBSXIfKvwi3Ynq/zHbjEj4MIPYftiY1CTaD4vyT9owiHHC4CTP2S4JhD91XI9gqzULkwNLRirADt2+Hss9PcFvQU+jbkO00USvtTthvWQmbY/lraQ7Mdu7QrNwVc6tDSopYOBBg0wlTwtBxNexbysxTbXgD46czchvy8Z26vZvwEKf5QTaKhxRM6/BirF53LmjDVgfsi1Ws15rqEH9V087O98NMvX3syhLHwVLMwpGbrsBwN/7U5YTGa7IzUJrhWu7iVMO9kCHf1ZQ53OrvP5bJI5mfNBPJim/m32bE9veR5cn7Ggr8IKHp4/ar3xuDI79Bqqd+99wAbClO8TQemQNgOXFCYx7/VDhReWe3c+YHCVDu9VzkOhWWR1NuBwmsadapsLeFHFboCHvU+qAJu1RTtJXTVeiML3HnH+pxwBdzqgVIFXKt1tJfw+bHs5Eqgur5axl4VMH41v3dlKVrCx3zmugKeNSJdMMzCM66TcEG+IbXE5Qs134ab1vVC5qCjkmf0Vggq8Jj2zwCAU+zfxjxZ5/hbqVoAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 34,
    height: 34,
    id: "img6",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiAQMAAAAAiZmBAAAAAXNSR0IB2cksfwAAAAZQTFRF4oAdNHb0DamZrwAAAAJ0Uk5TAP9bkSK1AAAAW0lEQVR4nHWPsRWAIAwFz2dh6QiMwmgwmqM4gqUFz28Aw7PQFNfkJ7nAfGAVr0opwyztsEjWWKWzsUCQLBSdgjSYbfSf24tfmTTom/uV4Cxu0q2mZthtH/P6xQ3vEHCfClwgogAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 34,
    height: 34,
    id: "img7",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiAQMAAAAAiZmBAAAAAXNSR0IB2cksfwAAAAZQTFRF4oAdNHb0DamZrwAAAAJ0Uk5TAP9bkSK1AAAAXUlEQVR4nGNgYP7AAATy/0Fk/f8DDAyM//8DhZj////BwMD+//8fBgZ+MCn///8/MAlUag8nG4CaYOQBLOR/JBKXGogJ9nASZgvERn4wCXEJxFVAFz6AuRbqcpAvAOe5biNOrIZyAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 34,
    height: 34,
    id: "img8",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiAQMAAAAAiZmBAAAAAXNSR0IB2cksfwAAAAZQTFRF4oAdNHb0DamZrwAAAAJ0Uk5TAP9bkSK1AAAAXElEQVR4nHWPuxGAIBAFn0NAaAmWYmlQmqVYgqGB43JwYMCMF2xyn7cnhUtWO5WQpQCnFMEaK9yNj7TBWwc7bSF9zJ1MPH44ZtLEcdlTPNHTYzNxq6UZum03r18UtjRwCdRuZ24AAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("use", {
    id: "<Path>",
    href: "#img1",
    x: 55,
    y: 80
  }), /*#__PURE__*/React.createElement("use", {
    id: "<Path>",
    href: "#img2",
    x: 55,
    y: 30
  }), /*#__PURE__*/React.createElement("use", {
    id: "<Path>",
    href: "#img3",
    x: 7,
    y: 81
  }), /*#__PURE__*/React.createElement("use", {
    id: "<Path>",
    href: "#img4",
    x: 88,
    y: 132
  }), /*#__PURE__*/React.createElement("use", {
    id: "<Path>",
    href: "#img5",
    x: 126,
    y: 30
  }), /*#__PURE__*/React.createElement("use", {
    id: "<Path>",
    href: "#img6",
    x: 232,
    y: 119
  }), /*#__PURE__*/React.createElement("use", {
    id: "<Path>",
    href: "#img7",
    x: 287,
    y: 119
  }), /*#__PURE__*/React.createElement("use", {
    id: "<Path>",
    href: "#img8",
    x: 343,
    y: 119
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.848b5d375ab905d6cfb9b50ca15a57e1.svg";
export { ForwardRef as ReactComponent };